// import css before other files to preserve ordering
import './bundle.projectGeisingerAccount.css';

// import component js
import FlowStepper from './elements/modifiers/flowStepper/flowStepper';

function componentSetup() {
  FlowStepper();
}
document.addEventListener('DOMContentLoaded', componentSetup);
